import global from '../patterns/global-variables';
import $ from 'jquery';
window.jQuery = $;
import './vendor/jquery.validate.min.js';
import './vendor/jquery.additional-methods.min.js';
import modal from '../patterns/modal.js';
import utils from '../patterns/utils';
import PL_utils from '../patterns/pl-utils.js';

const body = document.querySelector('body');
const ModalTriggers = document.querySelectorAll("[data-component='modal']");
const isEDMode = window.location.href.indexOf('ed=1') > -1;
var errorID;
var addressOldValue = document.querySelector('#register-address')?.value || '';
var stateOldValue = document.querySelector('#register-address-state')?.value || '';
var cityOldValue = document.querySelector('#register-city')?.value || '';
var zipcodeOldValue = document.querySelector('#register-zipcode')?.value || '';


window.dataLayer = window.dataLayer || [];

// ModalHooks shared by modal exit and modal exit-alt
const modalHooks = {
  _hasScrolledToBottom: false,
  _addModalError: function (target) { },
  _removeModalError: function (target) { },
  beforeOpen: function (target) {
    PL_utils.addClass('modal-open', body);
  },
  afterOpen: function (target) { },
  onContinue: function (e, target) { },
  onCancel: function () {
    return false;
  },
  beforeClose: function () {
    resetEmailVerificationModal();
    return false;
  },
  afterClose: function () {
    PL_utils.removeClass('modal-open', body);
    closeElementFocus();
  },
  setSize: function () {
    return false;
  },
  onScreenshot: function () {
    return false;
  },
  onInit: function (target) {

  }
};

const modalOpts = {
  enableBackdropClose: true
};

const showErrorMessage = (fieldId, labelId) => {
  const field = document.getElementById(fieldId);
  const fieldLabelError = document.querySelector(`#${labelId} > p.form-error`);
  field.setAttribute("aria-invalid", "true");
  field.classList.add("error");
  fieldLabelError.classList.remove("hidden");
}

const showErrorModal = (modalID) => {
  const errorModal = modal.initModal(document.querySelector(modalID), modalHooks, modalOpts);
  errorModal.showModal();
};

const initErrorModal = (data) => {
  var ModalTarget;
  switch (errorID) {
  case "E1102":
    window.dataLayer.push({ 'event': 'Form_Error', 'Form_Name': 'Sign Up', 'Form_Field': 'npi', 'Form_Field_Error': 'The NPI number you entered cannot be found.', });
    ModalTarget = '.modal-login-all-error';
    break;
  case "E1103":
    window.dataLayer.push({ 'event': 'Form_Error', 'Form_Name': 'Sign Up', 'Form_Field': 'dea', 'Form_Field_Error': 'The DEA number you entered cannot be found.', });
    ModalTarget = '.modal-login-all-error';
    break;
  case "E1104":
  case "E1105":
    window.dataLayer.push({ 'event': 'Form_Error', 'Form_Name': 'Sign Up', 'Form_Field': 'last-name', 'Form_Field_Error': 'The credentials you entered cannot be found.', });
    ModalTarget = '.modal-login-all-error';
    break;
  case "E1106":
    ModalTarget = '.modal-access-listings';
    break;
  case "E000":
  default:
    window.location.href = "/server-error";
    break;
  }

  if (ModalTarget) {
    const ModalEle = document.querySelector(ModalTarget);
    applyAccessibility(ModalEle);
    updateModal(ModalEle, data);
    showErrorModal(ModalTarget);
    ModalEle.focus();
  }
};

const showSentModal = (data) => {
  const ModalEle = document.querySelector('.modal-login-email-error');
  applyAccessibility(ModalEle);
  updateModal(ModalEle, data);
  showErrorModal('.modal-login-email-error');
  ModalEle.focus();
}

const closeElementFocus = () => {
  var inputFieldEl;
  switch (errorID) {
  case "E1102":
  case "E1104":
  case "E1105":
  default:
    inputFieldEl = "npi";
    break;
  case "E1103":
    inputFieldEl = "dea";
    break;
  case "E1106":
  case "E1107":
    inputFieldEl = "email";
    break;
  }
  const focusEl = document.getElementById(inputFieldEl);
  console.log("focusEl: ", focusEl);
  focusEl.focus();
};

const applyAccessibility = (ModalEle) => {
  const el_label = ModalEle.querySelector("[data-label]");
  if (el_label != null && !isEDMode) {
    ModalEle.setAttribute("aria-labelledby", el_label.innerHTML);
  }
};

const updateModal = (ModalEle, data) => {
  if (ModalEle.matches('.modal-login-email-error')) {
    ModalEle.querySelector('.verify-email strong').innerText = data.email;
  }
}

const resetEmailVerificationModal = () => {
  const modalEL = document.querySelector('.modal-login-email-error2');
  if (modalEL) {
    const editemailbtn = modalEL.querySelector('.edit-email');
    const editemailCancelbtn = modalEL.querySelector('.edit-email-cancel');
    const verifyEmailEl = modalEL.querySelector('.verify-email');
    const verifyEmailInputEl = modalEL.querySelector('.validate-email');
    PL_utils.removeClass("hidden", verifyEmailEl);
    PL_utils.removeClass("hidden", editemailbtn);
    PL_utils.addClass("hidden", verifyEmailInputEl);
    PL_utils.addClass("hidden", editemailCancelbtn);
  }
}

const kinetiqScreenshot = () => {
  if (
    window.location.search.substring(1).split('&').indexOf('modal=dea') > -1 ||
    window.location.search.substring(1).split('&').indexOf('modal=npi') > -1 ||
    window.location.search.substring(1).split('&').indexOf('modal=all') > -1
  ) {
    showErrorModal('.modal-login-all-error');
  } else if (window.location.search.substring(1).split('&').indexOf('modal=email4') > -1) {
    showErrorModal('.modal-access-listings');
  } else if (window.location.search.substring(1).split('&').indexOf('modal=email3') > -1) {
    showErrorModal('.modal-login-email-error2');
  } else if (window.location.search.substring(1).split('&').indexOf('modal=email2') > -1) {
    showErrorModal('.modal-login-email-error2');
  } else if (window.location.search.substring(1).split('&').indexOf('modal=email') > -1) {
    showErrorModal('.modal-login-email-error');
  }
};

const lookupAddress = function () {
  const addressNewValue = document.querySelector('#register-address').value;
  const stateNewValue = document.querySelector('#register-address-state').value;
  const cityNewValue = document.querySelector('#register-city').value;
  const zipcodeNewValue = document.querySelector('#register-zipcode').value;

  if ((addressNewValue && stateNewValue && cityNewValue && zipcodeNewValue)
  && (`${addressNewValue}|${stateNewValue}|${cityNewValue}|${zipcodeNewValue}` != `${addressOldValue}|${stateOldValue}|${cityOldValue}|${zipcodeOldValue}`)) {
    utils.setButtonLoadingState('#validate-credentials', '#validate-credentials-loading', true);
    $.ajax(global.API_ENDPOINT() + '/address/lookup', {
      data: JSON.stringify({
        'anonymousToken': utils.getAnonymousToken(),
        'address': addressNewValue,
        'state': stateNewValue,
        'city': cityNewValue,
        'zipcode': zipcodeNewValue,
      }),
      dataType: 'json',
      method: 'POST',
      xhrFields: {
        withCredentials: true,
      }
    })
    .done(function (resp) {
      if (resp.success) {
        document.querySelector('#register-latitude').value = resp.data.latitude;
        document.querySelector('#register-longitude').value = resp.data.longitude;
      } else {
        document.querySelector('#register-latitude').value = '';
        document.querySelector('#register-longitude').value = '';
        console.error(JSON.stringify(resp));
      }
    })
    .fail(function (err) {
      console.error(JSON.stringify(err));
    })
    .always(() => {
      utils.setButtonLoadingState('#validate-credentials', '#validate-credentials-loading', false);
    })
  }

  addressOldValue = addressNewValue;
  stateOldValue = stateNewValue;
  cityOldValue = cityNewValue;
  zipcodeOldValue = zipcodeNewValue;
}

export default () => {
  if (isEDMode) {
    kinetiqScreenshot();
  }

  // Lookup address after address form populated
  document.querySelector('#register-address').addEventListener('blur', lookupAddress);
  document.querySelector('#register-address-state').addEventListener('blur', lookupAddress);
  document.querySelector('#register-city').addEventListener('blur', lookupAddress);
  document.querySelector('#register-zipcode').addEventListener('blur', lookupAddress);

  //Only allow the following to be typed in: digits, blank spaces, (, ), -
  document.getElementById("register-phone").addEventListener("input", (e) => {
    const replaceRegex = /[^()\d\s-]/g;
    e.target.value = e.target.value.replace(replaceRegex, "");
  });

  $.validator.addMethod("digitsOnly", function(value, element) {
    return this.optional(element) || /^\d{10}$/.test(value.replace(/\D/g, ""));
  }, "");

  //form submission
  $('#sign-up-form').validate({
    focusInvalid: false,
    rules: {
      'npi': {
        required: true
      },
      'dea': {
        required: true
      },
      'last-name': {
        required: true
      },
      'email': {
        required: true,
        email: true,
        pattern: "^(?!(abuse|admin|administrator|groupadmin|info|webmaster|postmaster|support)@)(([0-9a-zA-Z])+([-._'+&]))*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$"
      },
      'register-address': {
        required: true
      },
      'register-address-state': {
          required: true
      },
      'register-city': {
          required: true,
      },
      'register-zipcode': {
          required: true,
          digits: true,
          minlength: 5,
      },
      'register-phone': {
          required: true,
          digitsOnly: true,
          minlength: 10,
      },
    },
    showErrors: function (errorMap, errorList) {
      // The arguments in errorList contain only those elements currently validated.
      // Refer to the form.successList for all the valid field,
      // and remove the error message that's associated to it.
      // Ref: https://jqueryvalidation.org/validate/  => showErrors
      this.successList.forEach((e) => {
        const targetName = e.name;
        const targetElements = $(`[name='${targetName}']`);
        const errorElement = $(`#${targetName}-label .form-error`);

        $(targetElements).removeClass('error');
        errorElement.addClass('hidden');

        if (targetName == "register-phone") {
            $('#register-ext').removeClass('error-padding');
        }
      });

      errorList.forEach((error) => {
        const targetName = error.element.name;
        const { method } = error;
        const targetElements = $(`[name='${targetName}']`);
        const errorElement = $(`#${targetName}-label .form-error`);

        targetElements.addClass('error');
        errorElement.removeClass('hidden');

        window.dataLayer.push({ 'event': 'Form_Error', 'Form_Name': 'Sign Up', 'Form_Field': targetName, 'Form_Field_Error': errorElement.text(), });

        $(targetElements).attr('aria-invalid', 'true');

        if (targetName == "register-phone") {
            $('#register-ext').addClass('error-padding');
        }
      });
    },
    submitHandler: function (form) {
      //Submit the form

      const formData = $(form).serializeArray();
      const postData = { 'anonymousToken': utils.getAnonymousToken() };

      formData.forEach(function (field) {
        postData[field.name] = field.name == "register-phone" ? field.value.replace(/\D/g, "") : field.value;
    });

      utils.setButtonLoadingState('#validate-credentials', '#validate-credentials-loading', true);

      $.ajax(global.API_ENDPOINT() + '/user/register_v1', {
        data: JSON.stringify(postData),
        dataType: 'json',
        method: 'POST',
        xhrFields: {
          withCredentials: true,
        }
      })
        .done(function (resp) {
          if (resp.success) {
            window.dataLayer.push({ 'event': 'Form_Success', 'Form_Name': 'Sign Up', });
            utils.setCookie('csrfToken', resp.data.csrfToken, { SameSite: 'Strict' });
            showSentModal(postData);
          } else {
            console.error(JSON.stringify(resp));
            errorID = resp.data.errorCode;
            postData.userToken = resp.data.userToken;

            if(errorID == "E1107") {
              showErrorMessage("register-address-state", "register-address-state-label");
            } else if (resp.data.errorCode == "E1101") {
              console.error(JSON.stringify(resp));
              Object.keys(resp.errors["dataservice-httpjson-validate"]).forEach(e =>  {
                  if(e == "npi") {
                    showErrorMessage("npi", "npi-label");
                  }
                  if(e == "dea") {
                    showErrorMessage("dea", "dea-label");
                  }
                  if(e == "last-name") {
                    showErrorMessage("last-name", "last-name-label");
                  }
                  if(e == "email") {
                    showErrorMessage("email", "email-label");
                  }
                  if(e == "register-address" || e == "register-latitude" || e == "register-longitude") {
                    showErrorMessage("register-address", "register-address-label");
                  }
                  if(e == "register-address-state") {
                    showErrorMessage("register-address-state", "register-address-state-label");
                  }
                  if(e == "register-city") {
                    showErrorMessage("register-city", "register-city-label");
                  }
                  if(e == "register-zipcode") {
                    showErrorMessage("register-zipcode", "register-zipcode-label");
                  }
                  if(e == "register-phone") {
                    showErrorMessage("register-phone", "register-phone-label");
                  }
              })
              document.querySelector('[aria-invalid="true"]').focus();
            } else {
              initErrorModal(postData);
            }
          }
          utils.setButtonLoadingState('#validate-credentials', '#validate-credentials-loading', false);
        })
        .fail(function (err) {
          console.error(JSON.stringify(err));
          utils.setButtonLoadingState('#validate-credentials', '#validate-credentials-loading', false);
          window.location.href = '/server-error';
        })
    },
    invalidHandler: function(form, validator) {
      var errors = validator.numberOfInvalids();
      if (errors) {
        validator.errorList[0].element.focus();
      }
    }
  });
}
